module.exports = __webpack_public_path__ + "img/k3-5.ecb55a45.png";